import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

type Messages = {
	errorTitle: MessageDescriptor;
	errorDescription: MessageDescriptor;
	errorDescriptionIssueTermRefresh: MessageDescriptor;
};
const messages: Messages = defineMessages({
	errorTitle: {
		id: 'spa-apps.project-settings.issue-type.team-managed.navigation.error-title',
		defaultMessage: 'Something went wrong.',
		description:
			'Title of error message displayed when we failed to render sidebar navigation items',
	},
	errorDescription: {
		id: 'spa-apps.project-settings.issue-type.team-managed.navigation.error-description',
		defaultMessage: "We couldn't load this issue type's details. Refresh and try again.",
		description: 'Error message displayed when we failed to render sidebar navigation items',
	},
	errorDescriptionIssueTermRefresh: {
		id: 'spa-apps.project-settings.issue-type.team-managed.navigation.error-description-issue-term-refresh',
		defaultMessage: "We couldn't load this work type's details. Refresh and try again.",
		description: 'Error message displayed when we failed to render sidebar navigation items',
	},
});
export default messages;
